import { createContext } from 'react'

export const BoardContext = createContext({
  boardOpen: false,
  showSidebarButton: false,
  showBoard: () => {},
  hideBoard: () => {},
})
